import React, { useState } from "react"
import * as styles from "./Hero.section.module.scss"

import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { useLink } from "../../hooks/index"
import { useSendEmail } from "../../hooks/function/useSendEmail"
import BreadcrumbTwo from "../BreadcrumbTwo/BreadcrumbTwo"


const HeroSection = ({ data }) => {
    const {
        name,
        title,
        subTitle,
        cta,
        widthBehavior,
        description,
        mobileHeroImage,
        heroImage,
        tagline,
        heroContentScaling,
        breadcrum,
    } = data

    const [emailInput, setEmailInput] = useState("")
    const [sendEmail, { response, loading, error }] = useSendEmail()

    const submitHandler = async e => {
        e.preventDefault()

        if (!emailInput) return

        await sendEmail(emailInput)
    }

    const heroTextClass =
        widthBehavior === "FullWidthBottom"
            ? `${styles.heroText} ${styles.boxedContent}`
            : widthBehavior === "BoxedContent"
                ? `${styles.heroText} ${styles.fullWidth}`
                : widthBehavior === "FullWidthAbove"
                    ? `${styles.heroTextAbove} ${styles.aboveWidth}`
                    : widthBehavior === "FullWidthCenter"
                        ? `${styles.heroText} ${styles.fullWidthCenter}`
                        : widthBehavior === "BoxedContentWidthForm"
                            ? `${styles.heroText} ${styles.contentWithForm}`
                            : `${styles.heroText} ${styles.defaultWidth}`

    return (
        <section
            className={`text-white ${styles.hero} ${styles.containerWithoutPadding}`}
        >
            {heroImage?.gatsbyImageData && (
                <div className={styles.heroImg}>
                    <GatsbyImage
                        image={heroImage.gatsbyImageData}
                        alt={heroImage.title || "Hero Image"}
                        loading="eager"
                        fetchPriority="high"
                        layout="constrained"
                        className={styles.heroImageGlobal}
                    />
                </div>
            )}
            {mobileHeroImage?.gatsbyImageData && (
                <div className={styles.mobileHeroImage}>
                    <GatsbyImage
                        image={mobileHeroImage.gatsbyImageData}
                        loading="eager"
                        fetchPriority="high"
                        alt={mobileHeroImage.title || "Hero Image"}
                        layout="constrained"
                        className={styles.mobile}
                    />
                </div>
            )}

            {breadcrum && (
                <div className="container">
                    <BreadcrumbTwo data={breadcrum} title={title} />
                </div>
            )}

            <div className={`container`}>
                <div className={heroTextClass}>
                    {widthBehavior === "BoxedContentWidthForm" ? (
                        <form className={styles.formContainer} onSubmit={submitHandler}>
                            {tagline && <p className={`global-spacing-bottom`}>{tagline}</p>}
                            {title && <h1 className=" global-spacing-bottom">{title}</h1>}
                            {description && (
                                <p>
                                    {description?.description}
                                </p>
                            )}
                            <div className={`global-spacing-top ${styles.form}`}>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className={styles.emailInput}
                                    aria-label="Email address"
                                    onChange={e => setEmailInput(e.target.value)}
                                />
                                <button type="submit" className={` onPrimaryOutline `}>I’m Interested</button>
                            </div>

                            <p className="global-spacing-top">
                                By subscribing, you agree to our Privacy Policy and consent to
                                receive updates.
                            </p>
                        </form>
                    ) : (
                        <>
                            {tagline && <p className={`global-spacing-bottom`}>{tagline}</p>}
                            {title && <h1 className=" global-spacing-bottom">{title}</h1>}
                            {description && (
                                <p>
                                    {description?.description}
                                </p>
                            )}
                            {cta && (
                                <ul className={`flex items-center global-spacing-top`}>
                                    {cta?.map((item, index) => (
                                        <li key={item.slug || item.id}>
                                            {" "}
                                            <Link
                                                to={`${useLink(item.target?.slug || item.slug)}`}
                                                className={
                                                    index === 0 ? "primaryFilled" : "onPrimaryOutline"
                                                }
                                                title={item.title}
                                            >
                                                {item.title === "Learn more" ? (
                                                    <>
                                                        {item.title}{" "}
                                                        <span className="sr_only">
                                                            {`Explore further content"`}{" "}
                                                        </span>{" "}
                                                    </>
                                                ) : (
                                                    item.title
                                                )}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </>
                    )}
                </div>
                <div className={styles.imgBg}></div>
            </div>
        </section>
    )
}

export default HeroSection
